import React, { useEffect, useState } from "react";
import { Flame, Loader2, RefreshCw, Crown } from "lucide-react";
import { toast } from "sonner";
import { bullHuntLatest, bullHuntRun } from "../lib/api";

export const BullHuntCard = () => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { bullHuntLatest().then(setD).catch(() => {}); }, []);
  const run = async () => {
    setBusy(true);
    try { setD(await bullHuntRun()); } catch (e) { toast.error(e?.response?.data?.detail || "Bull hunt failed"); } finally { setBusy(false); }
  };
  const ideas = d?.ideas || [];
  return (
    <div className="bg-[#0a0606] border border-amber-500/40 rounded-2xl p-4 space-y-3" data-testid="bull-hunt-card">
      <div className="flex items-center gap-2">
        <Flame className="w-5 h-5 text-amber-400" />
        <p className="text-amber-200 font-bold">Bull Hunt</p>
        <span className="text-[11px] text-amber-200/50 truncate">{d?.created_at ? `${new Date(d.created_at).toLocaleString()} CT` : "weekdays 7:30am CT"} · advisory, no orders</span>
        <button onClick={run} disabled={busy} data-testid="bull-hunt-run" className="ml-auto text-xs text-amber-300 border border-amber-500/40 rounded-full px-3 py-1 flex items-center gap-1.5 hover:bg-amber-500/10 disabled:opacity-50">
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <RefreshCw className="w-3.5 h-3.5" />} Run now
        </button>
      </div>
      {ideas.length === 0 ? <p className="text-xs text-amber-100/50">No hunt yet — tap Run now.</p> : ideas.map((i) => (
        <div key={i.ticker} className={`rounded-xl px-3 py-2 border ${i.top_pick ? "border-amber-400 bg-amber-500/10" : "border-white/10 bg-white/[0.02]"}`} data-testid={`bull-hunt-idea-${i.ticker}`}>
          <div className="flex items-center gap-2 flex-wrap">
            {i.top_pick && <span className="text-[10px] font-black tracking-widest text-[#030712] bg-amber-400 rounded px-1.5 py-0.5 flex items-center gap-1" data-testid="bull-hunt-top-pick"><Crown className="w-3 h-3" />TOP PICK</span>}
            <span className="font-bold text-cyan-50">{i.ticker}</span>
            <span className="text-[11px] text-cyan-300/50 capitalize">{i.market}</span>
            <span className="ml-auto text-[11px] text-cyan-100/80 tabular-nums">entry {i.entry} · stop <span className="text-rose-300">{i.stop}</span>{i.target ? <> · tgt <span className="text-emerald-300">{i.target}</span></> : null} · size {i.size_pct}%</span>
          </div>
          <p className="text-xs text-cyan-100/80 mt-1">{i.thesis}</p>
          {i.momentum && <p className="text-[11px] text-amber-200/50 mt-0.5">{i.momentum}</p>}
        </div>
      ))}
    </div>
  );
};
